import { useEffect, useState } from 'react';
import { useAppSelector } from '../../hooks';
import Slider from 'react-slick';
import classes from './NFTSelector.module.css';
import config from '../../config';
import '../../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../../node_modules/slick-carousel/slick/slick-theme.css';
import { Spinner } from 'react-bootstrap';

const settings = {
  infinite: false,
  dots: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 3,
};
interface SelectorProps {
  selectionLimit: number;
  availableNfts: any[];
  onSelectNft: (selectedNftId: any) => void;
  votesBlocked: boolean;
}
const NFTSelector = ({ selectionLimit, availableNfts, onSelectNft, votesBlocked }: SelectorProps) => {
  const account = useAppSelector(state => state.account.activeAccount);
  const [bees, setBees] = useState<any[]>([]);
  const [selectedBees, setSelectedBees] = useState<number[]>([]);
  const [isChecked, setIsChecked] = useState(false);

  const selectAll = (checked: boolean) => {
    if (availableNfts) {
      const updateBees = checked ? availableNfts.map(nft => nft.id) : [];
      setSelectedBees(updateBees)
      onSelectNft(updateBees);
    }
  }
  useEffect(() => {
    if (availableNfts) {
      const nfts = availableNfts.map((nft: any) => ({ ...nft, selected: selectedBees.some(bee => nft.id === bee) }))
      setBees(nfts)
      setIsChecked(availableNfts.length === selectedBees.length);
    }
  }, [selectedBees, availableNfts]);

  useEffect(() => {
    setSelectedBees(selectedBees.filter(bee => availableNfts.some(nft => nft.id === bee)))
  }, [availableNfts]);

  const onSelectBee = (selectedBeeId: number, selected: boolean) => {
    let updateBees: number[] = [];
    if (!(selectedBees.length < (selectionLimit || 0)) && selected) {
      selectedBees.pop();
      updateBees = [...selectedBees, selectedBeeId]
    } else {
      updateBees = selected ? [...selectedBees, selectedBeeId] : selectedBees.filter(bee => bee !== selectedBeeId);
    }
    setSelectedBees(updateBees)
    onSelectNft(updateBees);
  };

  if (!account) return null;

  return (
    <>
      {votesBlocked ?
        <div className={classes.beesContainerSelector}>
          <span>
            <Spinner animation="border" />
          </span>
        </div> :
        availableNfts.length > 0 ?
          (<div className={classes.beesContainerSelector}>
            <h5>Select your {selectionLimit > 1 ? config.labels.conllectionEntityPlural : config.labels.collectionEntitySingular}
              {availableNfts && selectionLimit > 1 && ` (${availableNfts.length} ${availableNfts.length > 1 ? 'Votes' : 'Vote'} Available)`}
            </h5>
            {selectionLimit > 1 &&
              <span>
                <svg
                  onClick={() => {
                    selectAll(!isChecked);
                    setIsChecked(!isChecked);
                  }}
                  className={`${classes.checkbox} ${isChecked ? classes.checkbox_active : ""}`}
                  aria-hidden="true"
                  viewBox="0 0 15 11"
                  fill="none"
                >
                  <path
                    d="M1 4.5L5 9L14 1"
                    strokeWidth="2"
                    stroke={isChecked ? "#fff" : "none"}
                  />
                </svg>
                Select All
              </span>
            }
            <Slider {...settings}>
              {bees?.map(t => (
                <div key={t.id} className={`${classes.bee}`}>
                  <img className={`${t.selected ? classes.selected : ''}`} src={t.image} alt={`${config.labels.collectionEntitySingular}_${t.id}`} onClick={() => onSelectBee(t.id, !t.selected)} />
                  <small
                    onClick={() => onSelectBee(t.id, !t.selected)}
                  >
                    #{t.id}
                  </small>
                </div>
              ))}
            </Slider>
          </div>) :
          <div className={classes.beesContainerSelector}>
            <h5>You don't have available {config.labels.conllectionEntityPlural}</h5>
          </div>
      }
    </>
  );
};

export default NFTSelector;
